import './slider/ProductSlider.scss';
import './QuickPurchaseLastOrder.scss';

import { b2x } from '@b2x/react/src';
import React from 'react';
import { SwiperSlide } from 'swiper/react';

import { Button } from './Button';
import { t } from './i18n/i18n';
import { ProductTile } from './ProductTile';
import { Slider } from './slider/Slider';

interface QuickPurchaseLastOrderProps {}

export const QuickPurchaseLastOrder = (props: QuickPurchaseLastOrderProps) => {
  const {
    addAllProductsToCart,
    fetching,
    lastOrder,
    lastProductsOrdered: lastProductsOrderedFiltered,
  } = b2x.useLastOrder();
  const { getPagePath } = b2x.useAppStaticContext();

  // Toppa
  const lastProductsOrdered = React.useMemo(
    () =>
      lastProductsOrderedFiltered.filter((product) => {
        const firstSkuPrice = product.skus?.[0]?.price?.value ?? 0;
        return firstSkuPrice > 0.01;
      }),
    [lastProductsOrderedFiltered],
  );

  return lastOrder && lastProductsOrdered.length > 0 ? (
    <div className="quick-purchase-last-order">
      <div className="row">
        <div className="col-12 text-center">
          <h2 className="mb-lg-5 mb-4 fw-bold">{t('quickPurchaseLastOrder.sectionTitle')}</h2>
        </div>
      </div>
      <div className="row justify-content-center align-items-center">
        <div className="col-md-6 col-lg-3 col-xl-3">
          <div className="last-order-detail text-center p-xl-0 px-3 py-5 mb-lg-0 mb-4">
            <p className="h3 mb-3">{t('quickPurchaseLastOrder.title')}</p>
            <p className="h5 fs-3 mb-4">{b2x.formatDate(lastOrder.creationDate)}</p>
            <p className="h4 fs-4 mb-3 fw-bold">
              {t('quickPurchaseLastOrder.total', {
                value: b2x.formatCurrency(lastOrder.totalCost),
              })}
            </p>
            <Button
              aria-label={t('accessibility.button.quickPurchaseLastOrder')}
              disabled={fetching}
              label={t('misc.quickPurchaseLastOrder.addAllToCart')}
              onClick={addAllProductsToCart}
              type="button"
              variant="primary"
            />
            <p className="extra-small mt-4 mb-0 text-center">{t('quickPurchaseLastOrder.totalNote')}</p>
          </div>
        </div>
        <div className="col-lg-9 col-xl-6">
          <b2x.Listing name={'Acquisto veloce ultimo ordine'} products={lastProductsOrdered}>
            <ProductSliderLastOrder products={lastProductsOrdered} />
          </b2x.Listing>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="text-center mt-lg-4 mb-lg-3">
            <b2x.router.NavLink className="btn text-black btn-link" to={getPagePath('SITE_CCN_ORDERS')}>
              {t('misc.quickPurchaseLastOrder.myOrders')}
            </b2x.router.NavLink>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div></div>
  );
};

interface ProductSliderLastOrderProps {
  products: Array<b2x.ProductApiDto>;
}

const ProductSliderLastOrder = ({ products }: ProductSliderLastOrderProps) => {
  return (
    <div className="product-slider position-relative">
      <b2x.EqualHeight>
        <Slider
          navigation
          responsive={{
            lg: {
              slidesPerView: 2.4,
            },
            sm: {
              slidesPerView: 2.4,
            },
            xl: {
              slidesPerView: 2,
            },
          }}
          slidesPerView={1.4}
          spaceBetween={20}
        >
          {products.map((product, index) => (
            <SwiperSlide key={product.id}>
              <ProductTile product={product} productsPerRow={products.length} />
            </SwiperSlide>
          ))}
        </Slider>
      </b2x.EqualHeight>
    </div>
  );
};
